module.exports = __webpack_public_path__ + "images/_/programs/epsHybridPrimaries/images/characters/ian_hand_raised-384fabc0cb5b98efe85310c0d8c15540.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/images/characters/ian_hand_raised.png
// module id = 2295
// module chunks = 2